import React from 'react';
import LoadStatus from '../utilities/load-status.jsx';
import PropTypes from 'prop-types';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    this.clickHandler = this.clickHandler.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  clickHandler(e) {
    if (e.currentTarget.className.indexOf('btn-modal-cta') >= 0 && this.props.action) {
      this.props.action(() => { this.closeModal(true); });
    }
    if (e.currentTarget.className.indexOf('btn-modal-cta') < 0) {
      this.props.customButtons.forEach(button => {
        if (e.currentTarget.className.indexOf(button.name) >= 0 && button.action) {
          button.action(() => { this.closeModal(true); });
        }
      });
    }
  }

  closeModal(outsideJob = false) {
    this.setState({ open: false }, () => {
      if (outsideJob === true) {
        document.getElementById(`${this.props.id}_close-btn`).click();
      }
      this.props.closeAction();
    });
  }

  render() {
    const launcher = this.props.launcherIsLink ? (
      <a
        id={this.props.launcherId}
        className={`${this.props.launcherTheme}${this.props.hideLauncher ? ' hidden' : ''}`}
        onClick={() => {
          this.setState({ open: true });
          this.props.launchAction();
        }}
        data-toggle="modal"
        data-target={`#${this.props.id}`}
      >
        <i className={`fa ${this.props.icon}`} />
        <span>
          {this.props.icon && this.props.launcherText ? ' ' : ''}
          {this.props.launcherText}
        </span>
      </a>
    ) : (
      <button
        id={this.props.launcherId}
        type="button"
        className={`btn button-modal-launcher ${this.props.launcherTheme}${this.props.hideLauncher ? ' hidden' : ''}`}
        style={{ margin: '0 0.5em 0 0' }}
        onClick={() => {
          this.setState({ open: true });
          this.props.launchAction();
        }}
        data-toggle="modal"
        data-target={`#${this.props.id}`}
      >
        <i className={`fa ${this.props.icon}`} />
        <span>
          {this.props.icon && this.props.launcherText ? ' ' : ''}
          {this.props.launcherText}
        </span>
      </button>
    );
    return (
      <div className={this.props.inline ? 'd-inline' : null}>
        {launcher}
        <div id={this.props.id} className={`modal ${this.props.theme}${this.props.fades ? ' fade' : ''}`} role="dialog">
          <div className="modal-dialog">
            <div className="modal-content row">
              <div className="modal-header col-xs-12">
                <button id={`${this.props.id}_close-btn`} type="button" className="close" data-dismiss="modal" onClick={this.closeModal}>&times;</button>
                <h4 className="modal-title">
                  {this.props.modalHeadline}
                  <br />
                  <small>{this.props.modalSubheadline}</small>
                </h4>
              </div>
              <div className="modal-body col-xs-12">
                {this.state.open ? (
                  !this.props.loading ? (
                    <div>
                      {this.props.modalContent}
                      {this.props.children}
                    </div>
                  ) : (
                    <div
                      id={`${this.props.id}-load-status-container`}
                      className="text-center align-middle"
                      style={{
                        backgroundColor: 'rgba(150, 150, 150, 0.05)',
                        position: 'absolute',
                        borderRadius: '5px',
                        top: 0, right: '10px', bottom: 0, left: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <LoadStatus size="3em" color="#848484" spins />
                    </div>
                  )
                ) : ''}
              </div>
              <div className="modal-footer col-xs-12">
                { this.state.open && !this.props.loading ? (
                  <div>
                    {this.props.modalFooter}
                    {this.props.hideCloseButton ? '' : (
                      <button
                        className={`btn-modal-cancel btn ${this.props.closeButtonTheme}`}
                        data-dismiss="modal"
                        onClick={this.closeModal}
                        style={{ margin: '0 0.5em 0 0' }}
                      >
                        Cancel
                      </button>
                    )}
                    {this.props.customButtons.length > 0 ? this.props.customButtons.map((btn, b) => {
                      return (
                        <button
                          key={b}
                          type="button"
                          className={`btn ${btn.name || 'undefined-btn-modal-action'} ${btn.theme || 'btn-default'}`}
                          style={{ margin: '0 0.5em 0 0' }}
                          onClick={this.clickHandler}
                        >
                          {btn.icon ? (<i className={`fa ${btn.icon}`} />) : ''}
                          {btn.icon && btn.text ? ' ' : ''}
                          {btn.text || ''}
                        </button>
                      );
                    }) : ''}
                    {this.props.hideCTAButton ? '' : (
                      <button
                        className={`btn-modal-cta btn ${this.props.ctaButtonTheme}`}
                        style={{ margin: '0 0.5em 0 0' }}
                        onClick={this.clickHandler}
                      >
                        {this.props.ctaButtonText}
                      </button>
                    )}
                  </div>
                ) : '' }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
Modal.propTypes = {
  theme: PropTypes.string,
  fades: PropTypes.bool,
  inline: PropTypes.bool,
  hideLauncher: PropTypes.bool,
  loading: PropTypes.bool,
  launcherId: PropTypes.string,
  id: PropTypes.string.isRequired,
  launcherTheme: PropTypes.string,
  hideCloseButton: PropTypes.bool,
  closeButtonTheme: PropTypes.string,
  hideCTAButton: PropTypes.bool,
  ctaButtonTheme: PropTypes.string,
  icon: PropTypes.string,
  launcherText: PropTypes.string,
  launcherIsLink: PropTypes.bool,
  action: PropTypes.func,
  modalHeadline: PropTypes.string,
  modalSubheadline: PropTypes.string,
  ctaButtonText: PropTypes.string,
  launchAction: PropTypes.func,
  closeAction: PropTypes.func,
  customButtons: PropTypes.array,
  modalContent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  modalFooter: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ])
};
Modal.defaultProps = {
  theme: 'modal-default',
  fades: false,
  inline: false,
  hideLauncher: false,
  loading: false,
  hideCTAButton: false,
  hideCloseButton: false,
  closeButtonTheme: 'btn-default',
  ctaButtonTheme: 'btn-default',
  launcherTheme: 'btn-default',
  launcherIsLink: false,
  launcherText: 'Launch',
  icon: '',
  ctaButtonText: 'Ok',
  customButtons: [],
  launchAction: () => {},
  closeAction: () => {}
};

export default Modal;
